import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { DeviceService } from '../../device.service';
import { UsersService } from 'src/app/users/users.service';
import { DeviceFactory } from '../../device-factory/device-factory';
import { CommonService } from 'src/app/shared/services/common.service';

@Component({
	selector: 'app-im-device-global-records',
	templateUrl: './im-device-global-records.component.html',
	styleUrls: ['./im-device-global-records.component.css']
})
export class ImDevicesGlobalRecordsComponent implements OnInit, OnChanges {
	@Input() device: any = {};
	@Input() currentSite: any;
	@Input() enterprisePermissions: any = {};

	meterGlobalRecords: any = {};

	meteredSelectedField: string[] = [
		'mac_address',
		'debug_start',
		'debug_end',
		'events_start',
		'events_end',
		'rt_start',
		'rt_end',
		'positive_peak_power',
		'generated_energy',
		'min_voltage',
		'max_voltage',
		'max_current',
		'energy_duration',
		'negative_peak_power',
		'consumed_energy',
		'start_log_counter',
		'start_rt_counter',
		'start_glitch_counter',
		'glitch_start',
		'glitch_end',
		'last_debug_id',
		'last_event_id',
		'last_glitch_id',
		'last_rt_id',
		'historical_positive_peak_power',
		'historical_min_voltage',
		'historical_max_voltage',
		'historical_max_current',
		'total_energy_duration',
		'historical_negative_peak_power',
		"historical_consumed_kvarh",
		"historical_generated_kvarh",
		'historical_min_voltage_ll',
		'historical_max_voltage_ll',
		'generated_kwhr_reset_snapshot',
		'consumed_kwhr_reset_snapshot',
		'generated_kvarh_reset_snapshot',
		'consumed_kvarh_reset_snapshot',
		'cellular_rssi',
		'cellular_connected',
		'cellular_longitude',
		'cellular_latitude',
		'cellular_imsi',
		'cellular_imei',
		'cellular_iccid',
		'cellular_cereg_val',
		'cellular_failure_type',
		'cellular_access_technology_selected',
		'operator_in_numeric_format',
		'cellular_band',
		'cellular_channel',
		'cellular_ip',
		'cellular_gateway',
		'cellular_netmask',
		'cellular_detailed_failure_flags',
		'cell_module_id',
		'cell_fw_version',
		'prev_meter_consumed_kwhr',
		'prev_meter_generated_kwhr',
		'prev_meter_consumed_kvarh',
		'prev_meter_generated_kvarh',
		'prev_meter_historical_positive_peak_power',
		'prev_meter_historical_negative_peak_power',
		'prev_meter_historical_max_voltage',
		'prev_meter_historical_min_voltage',
		'prev_meter_historical_max_current',
		'prev_meter_consumed_energy_duration',
		'prev_meter_historical_max_voltage_ll',
		'prev_meter_historical_min_voltage_ll',
		'prev_meter_sn',
		'prev_meter_generated_energy_duration',
	];

	permissionMapperKey: string = '';
	constructor(
		public deviceService: DeviceService,
		private userService: UsersService,
		public commonService: CommonService,
	) {}

	ngOnInit() {}

	ngOnChanges() {
		this.getMeterGlobalRecords();
		this.permissionMapperKey = DeviceFactory.createDevice(this.device.config_info.sct_device_type).config.permissionMapperKey;
	}

	getMeterGlobalRecords() {
		const device = {};
		for (const item of this.meteredSelectedField) {
			device[item] = this.device.config_info[item];
		}

		return this.meterGlobalRecords = device;
	}

	readonly noReadingFlagByField: Record<string, string> = {
		historical_min_voltage: 'historical_min_voltage',
		historical_max_voltage: 'historical_min_voltage',
		historical_min_voltage_ll: 'historical_min_voltage_ll',
		historical_max_voltage_ll: 'historical_min_voltage_ll',
		historical_max_current: 'historical_min_voltage',
		prev_meter_historical_min_voltage: 'prev_meter_historical_min_voltage',
		prev_meter_historical_max_voltage: 'prev_meter_historical_min_voltage',
		prev_meter_historical_min_voltage_ll: 'prev_meter_historical_min_voltage_ll',
		prev_meter_historical_max_voltage_ll: 'prev_meter_historical_min_voltage_ll',
		prev_meter_historical_max_current: 'prev_meter_historical_min_voltage',
	};

	minRecordValue(field: string, emptyText: string, raw = false): string {
		const value = this.meterGlobalRecords[field];

		if (this.commonService.hasNoReading(this.meterGlobalRecords[this.noReadingFlagByField[field]]))
			return this.commonService.NO_READING;

		if (value == null)
			return emptyText;

		return raw ? `${value}` : Number(value).toFixed(2);
	}

	checkHasAccess(field: string): boolean {
		return this.userService.hasAccessPermission(this.enterprisePermissions, `global_record.${field}`, 'read', null, this.permissionMapperKey);
	}

	canAccessNumbers() {
		return this.checkHasAccess('debug_end') ||
			this.checkHasAccess('events_end') ||
			this.checkHasAccess('rt_end') ||
			this.checkHasAccess('glitch_end') ||
			this.checkHasAccess('debug_start') ||
			this.checkHasAccess('events_start') ||
			this.checkHasAccess('rt_start') ||
			this.checkHasAccess('glitch_start');
	}

	canAccessCountersAndLastIds() {
		return this.checkHasAccess('start_log_counter') ||
			this.checkHasAccess('start_rt_counter') ||
			this.checkHasAccess('glitch_start') ||
			this.checkHasAccess('last_event_id') ||
			this.checkHasAccess('last_glitch_id') ||
			this.checkHasAccess('last_rt_id') ||
			this.checkHasAccess('last_debug_id');
	}

	canAccessPreviousMeterFields() {
		return this.checkHasAccess('debug_end');
	}
}
